export const recoverableMedicineStatuses = new Set(['failed', 'held', 'uncertain', 'not_started', 'cancelled']);

export function medicineAiRecoveryState(workspace, expectedGenerationId) {
  const generation = workspace?.contentGeneration, id = generation?.requestId || generation?.id;
  const failure = generation?.failure || {}, retry = generation?.retry || {};
  const replaced = Boolean(id && expectedGenerationId && id !== expectedGenerationId);
  const uncertain = generation?.status === 'uncertain' || failure.uncertain === true;
  let blockedReason = retry.blockedReason || '';
  if (uncertain) blockedReason = 'This request has unconfirmed usage. Resolve its saved charge before retrying.';
  else if (replaced) blockedReason = 'A newer generation already exists. Open its saved progress before starting more work.';
  else if (!generation || !id) blockedReason = 'Refresh saved progress to load the generation before retrying.';
  else if (!retry.allowed && !blockedReason) blockedReason = 'This saved generation cannot be retried yet. Refresh its progress for the latest status.';
  return { generation, id, failure, retry, replaced, uncertain, blockedReason,
    canRetry: Boolean(id && !replaced && !uncertain && retry.allowed === true && Number.isInteger(workspace?.revision)),
  };
}
